<div *ngIf="config" class="container-block">
  <ng-container *ngIf="!isViewAll">
    <app-position-in-config 
      [elementChoosing]="objectChoosing" 
      [device]="device"
      [idCellFrame]="'cell_frame_'+ objectChoosing._id + '_' +'0'">
    </app-position-in-config>
    <app-position-out-config 
      [elementChoosing]="objectChoosing" 
      [device]="device"
      [id_parent_choose]=" objectChoosing.id_block ? objectChoosing.id_block : objectChoosing.id_object">
    </app-position-out-config>
    <app-width-height-config 
      [elementChoosing]="objectChoosing"
      [device]="device" 
      [width]="class['frame-product-category-view-more']['width']" 
      [height]="class['frame-product-category-view-more']['height']"
      (changeWidthHeight)="changeWidthHeight($event)">
    </app-width-height-config>

    <!-- DANH SÁCH CÁC CONFIG -->
    <ul nz-menu nzMode="inline" [nzInlineCollapsed]="isCollapsed">
      <!-- HIỂN THỊ -->
      <li nz-submenu [nzTitle]="'hien_thi' | translate" [(nzOpen)]="openMap.menu1" (nzOpenChange)="openHandler('menu1')">
        <app-hide-show-config 
          [elementChoosing]="objectChoosing"
          [device]="device">
        </app-hide-show-config>
      </li>

      <!-- * Dùng cho frame-room-by-category-view-more -->
      <!-- GIÁ HIỂN THỊ -->
      <li *ngIf="objectChoosing.component === 'AtwFrameRoomByCategoryViewMore'" 
        nz-submenu [nzTitle]="'gia_hien_thi' | translate" [(nzOpen)]="openMap.menu99" (nzOpenChange)="openHandler('menu99')">
        <div class="mb-3">
          <nz-select [(ngModel)]="config['price_display']['field_name']" (ngModelChange)="updateConfig()">
            <nz-option nzValue="first_hour" [nzLabel]="'gia_gio_dau' | translate"></nz-option>
            <nz-option nzValue="second_hour" [nzLabel]="'gia_gio_sau' | translate"></nz-option>
            <nz-option nzValue="night" [nzLabel]="'gia_dem' | translate"></nz-option>
            <nz-option nzValue="day" [nzLabel]="'gia_ngay' | translate"></nz-option>
          </nz-select>
        </div>
      </li>

      <!-- CHỮ THÔNG BÁO KẾT QUẢ -->
      <li nz-submenu [nzTitle]="'chu_thong_bao_ket_qua' | translate" [(nzOpen)]="openMap.menu2" (nzOpenChange)="openHandler('menu2')">
        <!-- Hiển thị -->
        <div class="config-name">
          <p>{{'hien_thi' | translate}}</p>
          <nz-switch [(ngModel)]="config['show_notification_text']" (ngModelChange)="updateConfig()"></nz-switch>
        </div>
        <!-- Nội dung -->
        <div style="width: 100%">
          <mat-form-field style="width: 100%">
            <mat-label>{{'noi_dung' | translate}}</mat-label>
            <textarea matInput 
              [ngModel]="objectChoosing.staticdata['text_before_number_' + functionService.selectedLanguageCode] | vhLanguage : 'text_before_number' : objectChoosing.component" 
              (ngModelChange)="objectChoosing.staticdata['text_before_number_' + functionService.selectedLanguageCode] = $event" 
              (blur)="updateStaticData()"></textarea>
          </mat-form-field>
        </div>
        <!-- Nội dung -->
        <div style="width: 100%">
          <mat-form-field style="width: 100%">
            <mat-label> {{'noi_dung' | translate}}</mat-label>
            <textarea matInput 
              [ngModel]="objectChoosing.staticdata['text_after_number_' + functionService.selectedLanguageCode] | vhLanguage : 'text_after_number' : objectChoosing.component" 
              (ngModelChange)="objectChoosing.staticdata['text_after_number_' + functionService.selectedLanguageCode] = $event" 
              (blur)="updateStaticData()"></textarea>
          </mat-form-field>
        </div>
        <!-- Cấu hình chữ -->
        <app-text-format-config
          [objectChoosing]="objectChoosing" 
          [device]="device" 
          [staticdata]="objectChoosing.staticdata" 
          [class]="class" 
          [config]="config"
          [textContentClass]="class['frame-product-category-view-more__notification-text']"
          [textWrapperClass]="class['frame-product-category-view-more__notification-text']">
        </app-text-format-config>
        <!-- Giãn cách chữ -->
        <div>
          <div class="config-name">
            <span>{{'gian_cach_chu' | translate}}</span>
            <nz-input-number [nzMin]="0" [nzMax]="50" [nzStep]="0.1"
              [ngModel]="class['frame-product-category-view-more__notification-text']['letter-spacing'] | vhnumber" 
              (ngModelChange)="class['frame-product-category-view-more__notification-text']['letter-spacing'] = $event + 'px'"
              (nzBlur)="updateClass()">
            </nz-input-number>
          </div>
          <nz-slider [nzMin]="0" [nzMax]="50" [nzStep]="0.1"
            [ngModel]="class['frame-product-category-view-more__notification-text']['letter-spacing'] | vhnumber"
            (ngModelChange)="class['frame-product-category-view-more__notification-text']['letter-spacing'] = $event + 'px'"
            (nzOnAfterChange)="updateClass()" >
          </nz-slider>
        </div>
        <!-- Khoảng cách dòng -->
        <div>
          <div class="config-name">
            <span>{{'khoang_cach_dong' | translate}}</span>
            <nz-input-number [nzMin]="0" [nzMax]="50" [nzStep]="0.1"
              [(ngModel)]="class['frame-product-category-view-more__notification-text']['line-height']"
              (nzBlur)="updateClass()">
            </nz-input-number>
          </div>
          <nz-slider [nzMin]="0" [nzMax]="50" [nzStep]="0.1"
            [(ngModel)]="class['frame-product-category-view-more__notification-text']['line-height']"
            (nzOnAfterChange)="updateClass()">
          </nz-slider>
        </div>
      </li>
      <!-- CẤU HÌNH KHI KHÔNG TÌM THẤY SẢN PHẨM -->
      <li nz-submenu [nzTitle]="'cau_hinh_khi_khong_tim_thay_san_pham' | translate" [(nzOpen)]="openMap.menu3" (nzOpenChange)="openHandler('menu3')">
        <!-- Bật/tắt cấu hình -->
        <div class="config-name">
          <p>{{'cau_hinh' | translate}}</p>
          <nz-switch [(ngModel)]="config['is_empty']" (ngModelChange)="updateConfig()"></nz-switch>
        </div>
        <!-- Nếu có bật -->
        <ng-container *ngIf="config['is_empty']">
          <!-- Nội dung -->
          <div style="width: 100%">
            <mat-form-field style="width: 100%">
              <mat-label>{{'noi_dung' | translate}}</mat-label>
              <textarea matInput
                [ngModel]="objectChoosing.staticdata['no_data_' + functionService.selectedLanguageCode] | vhLanguage : 'no_data' : objectChoosing.component" 
                (ngModelChange)="objectChoosing.staticdata['no_data_' + functionService.selectedLanguageCode] = $event" 
                (blur)="updateStaticData()"></textarea>
            </mat-form-field>
          </div>
          <!-- Cấu hình chữ -->
          <app-text-format-config
            [objectChoosing]="objectChoosing" 
            [device]="device" 
            [staticdata]="objectChoosing.staticdata" [class]="class" [config]="config"
            [textContentClass]="class['frame-product-category-view-more__no-data']"
            [textWrapperClass]="class['frame-product-category-view-more__no-data']">
          </app-text-format-config>
          <!-- Giãn cách chữ -->
          <div>
            <div class="config-name">
              <span>{{'gian_cach_chu' | translate}}</span>
              <nz-input-number [nzMin]="0" [nzMax]="50" [nzStep]="0.1"
                [ngModel]="class['frame-product-category-view-more__no-data']['letter-spacing'] | vhnumber" 
                (ngModelChange)="class['frame-product-category-view-more__no-data']['letter-spacing'] = $event + 'px'"
                (nzBlur)="updateClass()">
              </nz-input-number>
            </div>
            <nz-slider [nzMin]="0" [nzMax]="50" [nzStep]="0.1"
              [ngModel]="class['frame-product-category-view-more__no-data']['letter-spacing'] | vhnumber"
              (ngModelChange)="class['frame-product-category-view-more__no-data']['letter-spacing'] = $event + 'px'"
              (nzOnAfterChange)="updateClass()" >
            </nz-slider>
          </div>
          <!-- Giãn cách dòng -->
          <div>
            <div class="config-name">
              <span>{{'khoang_cach_dong' | translate}}</span>
              <nz-input-number [nzMin]="0" [nzMax]="50" [nzStep]="0.1"
                [(ngModel)]="class['frame-product-category-view-more__no-data']['line-height']"
                (nzBlur)="updateClass()">
              </nz-input-number>
            </div>
            <nz-slider [nzMin]="0" [nzMax]="50" [nzStep]="0.1"
              [(ngModel)]="class['frame-product-category-view-more__no-data']['line-height']"
              (nzOnAfterChange)="updateClass()">
            </nz-slider>
          </div>
        </ng-container>
      </li>
      <!-- HIỆU ỨNG -->
      <li nz-submenu [nzTitle]="'hieu_ung' | translate" [(nzOpen)]="openMap.menu4" (nzOpenChange)="openHandler('menu4')">
        <app-choose-animations-config
          [elementChoosing]="objectChoosing"
          [id_object]="objectChoosing._id"
          [device]="device" [class]="class"
          [config]="config" [staticdata]="objectChoosing.staticdata"
          (openAnimationDetail)="openAnimationDetail($event)"
          [cursorClass]="class['frame-product-category-view-more']"
          [effect_hover]="effect_hover" [customize]="customize"
          [effectFileUsing]="'frame-products'">
        </app-choose-animations-config>
      </li>

      <!-- CẤU HÌNH CHO KHUNG -->
      <p class="mt-3 mb-2 font-bold" style="font-size: 1.05rem;">{{'cau_hinh_cho_khung' | translate}}</p>

      <!-- KIỂU DẠNG VÀ CHIA CỘT -->
      <li nz-submenu [nzTitle]="'kieu_dang_va_chia_cot' | translate" [(nzOpen)]="openMap.menu5" (nzOpenChange)="openHandler('menu5')">
        <app-total-row-col-products-config 
          [objectChoosing]="objectChoosing"
          [id_object]="objectChoosing._id" 
          [device]="device"
          [config]="config" 
          [class]="class"
          [productsClass]="class['frame-product-category-view-more__list']" 
          [productsConfig]="config">
        </app-total-row-col-products-config>
      </li>
      <!-- MÀU NỀN -->
      <li nz-submenu [nzTitle]="'mau_nen' | translate" [(nzOpen)]="openMap.menu6" (nzOpenChange)="openHandler('menu6')">
        <app-background-image-config [showImageConfig]="false" 
          [elementChoosing]="objectChoosing"
          [id_object]="objectChoosing._id" 
          [isBlock]="false"
          [config]="config" 
          [class]="class"
          [device]="device"
          [backgroundClass]="class['frame-product-category-view-more']" 
          [backgroundConfig]="config">
        </app-background-image-config>
      </li>
      <!-- ĐỔ BÓNG -->
      <li nz-submenu [nzTitle]="'do_bong' | translate" [(nzOpen)]="openMap.menu7" (nzOpenChange)="openHandler('menu7')">
        <app-shadow-config 
          [objectChoosing]="objectChoosing"
          [device]="device" 
          [config]="config" 
          [class]="class"
          [shadowClass]="class['frame-product-category-view-more']" 
          [shadowConfig]="config['box-shadow']"
          [objectChoosing]="objectChoosing">
        </app-shadow-config>
      </li>
      <!-- KIỂU VIỀN -->
      <li nz-submenu [nzTitle]="'kieu_vien' | translate" [(nzOpen)]="openMap.menu8" (nzOpenChange)="openHandler('menu8')">
        <app-borders-config 
          [elementChoosing]="objectChoosing"
          [id_object]="objectChoosing._id"
          [device]="device" 
          [class]="class"
          [borderClass]="class['frame-product-category-view-more']" >
        </app-borders-config>
        <!-- Nút mở rộng -->
        <div class="config-name view-more-btn">
          <p (click)="openViewAll(stylesField[0])">{{'mo_rong' | translate}} &#8594;</p>
        </div>
      </li>

      <!-- CẤU HÌNH PHẦN TỬ -->
      <p class="mt-3 mb-2 font-bold" style="font-size: 1.05rem;">{{'cau_hinh_cho_phan_tu' | translate}}</p>

      <!-- MÀU NỀN -->
      <li nz-submenu [nzTitle]="'mau_nen' | translate" [(nzOpen)]="openMap.menu9" (nzOpenChange)="openHandler('menu9')">
        <div class="config-name mt-0">
          <p>{{'mau_nen' | translate}}</p>
          <div>
            <input class="input-color" type="button" [cpOKButton]="true"
              [style.background]="class['frame-product-category-view-more__list--item']['background-color']"
              [(colorPicker)]="class['frame-product-category-view-more__list--item']['background-color']"
              (colorPickerClose)="updateClass()"/>
          </div>
        </div>
      </li>
      <!-- ĐỔ BÓNG -->
      <li nz-submenu [nzTitle]="'do_bong' | translate" [(nzOpen)]="openMap.menu10" (nzOpenChange)="openHandler('menu10')">
        <app-shadow-config 
          [objectChoosing]="objectChoosing"
          [device]="device" 
          [config]="config" 
          [class]="class"
          [shadowClass]="class['frame-product-category-view-more__list--item']"
          [shadowConfig]="config['frame-product-category-view-more__list--item']">
        </app-shadow-config>
      </li>
      <!-- KIỂU VIỀN -->
      <li nz-submenu [nzTitle]="'kieu_vien' | translate" [(nzOpen)]="openMap.menu11" (nzOpenChange)="openHandler('menu11')">
        <app-borders-config 
          [elementChoosing]="objectChoosing"
          [id_object]="objectChoosing._id"
          [device]="device" 
          [class]="class"
          [borderClass]="class['frame-product-category-view-more__list--item']" >
        </app-borders-config>
        <!-- Nút mở rộng -->
        <div class="config-name view-more-btn">
          <p (click)="openViewAll(stylesField[1])">{{'mo_rong' | translate}} &#8594;</p>
        </div>
      </li>

      <!-- CẤU HÌNH NÚT XEM THÊM -->
      <p class="mt-3 mb-2 font-bold" style="font-size: 1.05rem;">{{'cau_hinh_cho_nut_xem_them' | translate}}</p>

      <!-- KÍCH THƯỚC VÀ VỊ TRÍ -->
      <li nz-submenu [nzTitle]="'kich_thuoc_va_vi_tri' | translate" [(nzOpen)]="openMap.menu12" (nzOpenChange)="openHandler('menu12')">
        <!-- Canh lề -->
        <div>
          <p> {{'canh_le' | translate}}</p>
          <div class="font">
            <button class="font-text-btn" nz-button title="flex-start" 
              [nzType]="class['view-more-button__wrapper']['justify-content'] == 'flex-start'
                ? 'primary'
                : 'default'" 
              (click)="class['view-more-button__wrapper']['justify-content'] = 'flex-start'; updateClass()">
              <i nz-icon nzType="align-left" nzTheme="outline"></i>
            </button>
            <button class="font-text-btn" nz-button title="center"
              [nzType]="class['view-more-button__wrapper']['justify-content'] == 'center'
                ? 'primary'
                : 'default'" 
              (click)="class['view-more-button__wrapper']['justify-content'] = 'center'; updateClass()">
              <i nz-icon nzType="align-center" nzTheme="outline"></i>
            </button>
            <button class="font-text-btn" nz-button title="flex-end"
              [nzType]="class['view-more-button__wrapper']['justify-content'] == 'flex-end'
                ? 'primary'
                : 'default'" 
              (click)="class['view-more-button__wrapper']['justify-content'] = 'flex-end'; updateClass()">
              <i nz-icon nzType="align-right" nzTheme="outline"></i>
            </button>
          </div>
        </div>
        <!-- Chiều rộng -->
        <div>
          <div class="config-name">
            <span>{{'chieu_rong' | translate}}</span>
            <nz-input-number [nzMin]="1" [nzMax]="500" [nzStep]="1"
              [ngModel]="class['view-more-button']['width'] | vhnumber" 
              (ngModelChange)="class['view-more-button']['width'] = $event + 'px'"
              (nzBlur)="updateClass()">
            </nz-input-number>
          </div>
          <nz-slider [nzMin]="1" [nzMax]="500" [nzStep]="1"
            [ngModel]="class['view-more-button']['width'] | vhnumber"
            (ngModelChange)="class['view-more-button']['width'] = $event + 'px'"
            (nzOnAfterChange)="updateClass()" >
          </nz-slider>
        </div>
        <!-- Chiều cao -->
        <div>
          <div class="config-name">
            <span>{{'chieu_cao' | translate}}</span>
            <nz-input-number [nzMin]="1" [nzMax]="200" [nzStep]="1"
              [ngModel]="class['view-more-button']['height'] | vhnumber" 
              (ngModelChange)="class['view-more-button']['height'] = $event + 'px'"
              (nzBlur)="updateClass()">
            </nz-input-number>
          </div>
          <nz-slider [nzMin]="1" [nzMax]="200" [nzStep]="1"
            [ngModel]="class['view-more-button']['height'] | vhnumber"
            (ngModelChange)="class['view-more-button']['height'] = $event + 'px'"
            (nzOnAfterChange)="updateClass()" >
          </nz-slider>
        </div>
        <!-- Khoảng cách bên trên -->
        <div>
          <div class="config-name">
            <span>{{'khoang_cach_ben_tren' | translate}}</span>
            <nz-input-number [nzMin]="0" [nzMax]="200" [nzStep]="1"
              [ngModel]="class['view-more-button__wrapper']['padding-top'] | vhnumber" 
              (ngModelChange)="class['view-more-button__wrapper']['padding-top'] = $event + 'px'"
              (nzBlur)="updateClass()">
            </nz-input-number>
          </div>
          <nz-slider [nzMin]="0" [nzMax]="200" [nzStep]="1"
            [ngModel]="class['view-more-button__wrapper']['padding-top'] | vhnumber"
            (ngModelChange)="class['view-more-button__wrapper']['padding-top'] = $event + 'px'"
            (nzOnAfterChange)="updateClass()" >
          </nz-slider>
        </div>
        <!-- Khoảng cách bên dưới -->
        <div>
          <div class="config-name">
            <span>{{'khoang_cach_ben_duoi' | translate}}</span>
            <nz-input-number [nzMin]="0" [nzMax]="200" [nzStep]="1"
              [ngModel]="class['view-more-button__wrapper']['padding-bottom'] | vhnumber" 
              (ngModelChange)="class['view-more-button__wrapper']['padding-bottom'] = $event + 'px'"
              (nzBlur)="updateClass()">
            </nz-input-number>
          </div>
          <nz-slider [nzMin]="0" [nzMax]="200" [nzStep]="1"
            [ngModel]="class['view-more-button__wrapper']['padding-bottom'] | vhnumber"
            (ngModelChange)="class['view-more-button__wrapper']['padding-bottom'] = $event + 'px'"
            (nzOnAfterChange)="updateClass()" >
          </nz-slider>
        </div>
      </li>
      <!-- ĐỊNH DẠNG -->
      <li nz-submenu [nzTitle]="'dinh_dang' | translate" [(nzOpen)]="openMap.menu13" (nzOpenChange)="openHandler('menu13')">
        <div style="width: 100%">
          <!-- Nội dung -->
          <mat-form-field style="width: 100%">
            <mat-label> {{'noi_dung' | translate}}</mat-label>
            <textarea matInput
              [ngModel]="objectChoosing.staticdata['view_more_content_' + functionService.selectedLanguageCode] | vhLanguage : 'view_more_content' : objectChoosing.component" 
              (ngModelChange)="objectChoosing.staticdata['view_more_content_' + functionService.selectedLanguageCode] = $event" 
              (blur)="updateStaticData()"></textarea>
          </mat-form-field>
          <!-- Nội dung -->
          <mat-form-field style="width: 100%">
            <mat-label> {{'noi_dung_phia_sau' | translate}}</mat-label>
            <textarea matInput
              [ngModel]="objectChoosing.staticdata['view_more_content_after_' + functionService.selectedLanguageCode] | vhLanguage : 'view_more_content_after' : objectChoosing.component" 
              (ngModelChange)="objectChoosing.staticdata['view_more_content_after_' + functionService.selectedLanguageCode] = $event" 
              (blur)="updateStaticData()"></textarea>
          </mat-form-field>
          <app-text-format-config 
            [objectChoosing]="objectChoosing"
            [device]="device"  
            [class]="class" 
            [config]="config"
            [staticdata]="objectChoosing.staticdata"
            [textWrapperClass]="class['view-more-button']"
            [textContentClass]="class['view-more-button__content']">
          </app-text-format-config>
          <!-- Giãn cách chữ -->
          <div>
            <div class="config-name">
              <span>{{'gian_cach_chu' | translate}}</span>
              <nz-input-number [nzMin]="0" [nzMax]="50" [nzStep]="0.1"
                [ngModel]="class['view-more-button__content']['letter-spacing'] | vhnumber" 
                (ngModelChange)="class['view-more-button__content']['letter-spacing'] = $event + 'px'"
                (nzBlur)="updateClass()">
              </nz-input-number>
            </div>
            <nz-slider [nzMin]="0" [nzMax]="50" [nzStep]="0.1"
              [ngModel]="class['view-more-button__content']['letter-spacing'] | vhnumber"
              (ngModelChange)="class['view-more-button__content']['letter-spacing'] = $event + 'px'"
              (nzOnAfterChange)="updateClass()" >
            </nz-slider>
          </div>
          <!-- Khoảng cách dòng -->
          <div>
            <div class="config-name">
              <span>{{'khoang_cach_dong' | translate}}</span>
              <nz-input-number [nzMin]="0" [nzMax]="50" [nzStep]="0.1"
                [(ngModel)]="class['view-more-button__content']['line-height']"
                (nzBlur)="updateClass()">
              </nz-input-number>
            </div>
            <nz-slider [nzMin]="0" [nzMax]="50" [nzStep]="0.1"
              [(ngModel)]="class['view-more-button__content']['line-height']"
              (nzOnAfterChange)="updateClass()">
            </nz-slider>
          </div>
        </div>
      </li>
      <!-- MÀU NỀN -->
      <li nz-submenu [nzTitle]="'mau_nen' | translate" [(nzOpen)]="openMap.menu14" (nzOpenChange)="openHandler('menu14')">
        <div class="config-name mt-0">
          <p>{{'mau_nen' | translate}}</p>
          <div>
            <input class="input-color" type="button" [cpOKButton]="true"
              [style.background]="class['view-more-button']['background-color']"
              [(colorPicker)]="class['view-more-button']['background-color']"
              (colorPickerClose)="updateClass()"/>
          </div>
        </div>
      </li>
      <!-- ĐỔ BÓNG -->
      <li nz-submenu [nzTitle]="'do_bong' | translate" [(nzOpen)]="openMap.menu15" (nzOpenChange)="openHandler('menu15')">
        <app-shadow-config 
          [objectChoosing]="objectChoosing"
          [device]="device" 
          [config]="config" 
          [class]="class"
          [shadowClass]="class['view-more-button']" 
          [shadowConfig]="config['box-shadow-button']"
          [objectChoosing]="objectChoosing">
        </app-shadow-config>
      </li>
      <!-- KIỂU VIỀN -->
      <li nz-submenu [nzTitle]="'kieu_vien' | translate" [(nzOpen)]="openMap.menu16" (nzOpenChange)="openHandler('menu16')">
        <app-borders-config 
          [elementChoosing]="objectChoosing"
          [id_object]="objectChoosing._id"
          [device]="device" 
          [class]="class"
          [borderClass]="class['view-more-button']" >
        </app-borders-config>
        <!-- Nút mở rộng -->
        <div class="config-name view-more-btn">
          <p (click)="openViewAll(stylesField[1])">{{'mo_rong' | translate}} &#8594;</p>
        </div>
      </li>
      <!-- BIỂU TƯỢNG -->
      <li nz-submenu [nzTitle]="'bieu_tuong' | translate" [(nzOpen)]="openMap.menu17" (nzOpenChange)="openHandler('menu17')">
        <app-symbol-config 
          [objectChoosing]="objectChoosing"
          [device]="device" 
          [class]="class" 
          [config]="config" 
          [symbolClass]="class['view-more-button']"
          [fontSizeIconClass]="class['view-more-button__icon-wrapper']" 
          [symbolConfig]="config['icon']">
        </app-symbol-config>
      </li>
      <!-- HIỆU ỨNG KHI RÊ CHUỘT -->
      <li nz-submenu [nzTitle]="'hieu_ung_khi_re_chuot' | translate" [(nzOpen)]="openMap.menu18" (nzOpenChange)="openHandler('menu18')">
        <!-- Màu nền -->
        <div class="config-name mt-0">
          <p>{{'mau_nen' | translate}}</p>
          <div>
            <input class="input-color" type="button" [cpOKButton]="true"
              [style.background]="config['view-more-button-animation']['--view-more-button-background-color']"
              [(colorPicker)]="config['view-more-button-animation']['--view-more-button-background-color']"
              (colorPickerClose)="updateConfig()"/>
            </div>
        </div>
        <!-- Màu chữ -->
        <div class="config-name mt-0">
          <p>{{'mau_chu' | translate}}</p>
          <div>
            <input class="input-color" type="button" [cpOKButton]="true"
              [style.background]="config['view-more-button-animation']['--view-more-button-color']"
              [(colorPicker)]="config['view-more-button-animation']['--view-more-button-color']"
              (colorPickerClose)="updateConfig()"/>
          </div>
        </div>
        <!-- Màu icon -->
        <div class="config-name mt-0">
          <p>{{'mau_bieu_tuong' | translate}}</p>
          <div>
            <input class="input-color" type="button" [cpOKButton]="true"
              [style.background]="config['view-more-button-animation']['--view-more-button__icon-color']"
              [(colorPicker)]="config['view-more-button-animation']['--view-more-button__icon-color']"
              (colorPickerClose)="updateConfig()"/>
          </div>
        </div>
        <!-- Độ trong suốt -->
        <div>
          <div class="config-name">
            <span>{{'do_trong_suot' | translate}}</span>
            <nz-input-number [nzMin]="0" [nzMax]="1" [nzStep]="0.01"
              [(ngModel)]="config['view-more-button-animation']['--view-more-button-opacity']"
              (nzBlur)="updateConfig()">
            </nz-input-number>
          </div>
          <nz-slider [nzMin]="0" [nzMax]="1" [nzStep]="0.01"
            [(ngModel)]="config['view-more-button-animation']['--view-more-button-opacity']"
            (nzOnAfterChange)="updateConfig()">
          </nz-slider>
        </div>
        <!-- Thời gian hiệu ứng -->
        <div>
          <div class="config-name mt-4">
            <p class="m-0">{{ 'thoi_gian_hieu_ung' | translate }}</p>
            <nz-input-number [nzMin]="0" [nzMax]="10" [nzStep]="0.1" 
              [ngStyle]="{ marginLeft: '10px' }"
              [ngModel]="class['view-more-button']['transition'] | vhnumber" 
              (ngModelChange)=" class['view-more-button']['transition'] = $event + 's'"
              (nzBlur)="updateClass()">
            </nz-input-number>
          </div>
          <nz-slider [nzMin]="0" [nzMax]="10" [nzStep]="0.1"
            [ngModel]="class['view-more-button']['transition'] | vhnumber" 
            (ngModelChange)="class['view-more-button']['transition'] = $event + 's'"
            (nzOnAfterChange)="updateClass()">
          </nz-slider>
        </div>
      </li>
    </ul>
  </ng-container>

  <!-- HIỂN THỊ TIÊU ĐỀ MỞ RỘNG -->
  <div class="editor-header" *ngIf="isViewAll">
    <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
    <span (click)="isViewAll = !isViewAll">{{ currentViewAll.title | translate }}</span>
  </div>

  <!-- CHI TIẾT CẤU HÌNH MỞ RỘNG -->
  <div class="view-more" *ngIf="isViewAll">
    <!-- Cấu hình chi tiết viền của frame -->
    <div class="view_more-border" *ngIf="currentViewAll.index == 1">
      <app-borders-radius-config 
        [elementChoosing]="objectChoosing"
        [id_object]="objectChoosing._id"
        [device]="device" 
        [class]="class"
        [borderRadiusClass]="class['frame-product-category-view-more__list--item']">
      </app-borders-radius-config>
    </div>
    <!-- Cấu hình chi tiết viền của phần tử trong frame -->
    <div class="view_more-border" *ngIf="currentViewAll.index == 2">
      <app-borders-radius-config 
        [elementChoosing]="objectChoosing"
        [id_object]="objectChoosing._id"
        [device]="device" 
        [class]="class"
        [borderRadiusClass]="class['frame-product-category-view-more__list--item']">
      </app-borders-radius-config>
    </div>
    <!-- Cấu hình chi tiết hiệu ứng -->
    <div class="editor_effect-hover" *ngIf="currentViewAll.index == 3">
      <app-animations-config 
        [elementChoosing]="objectChoosing"
        [id_object]="objectChoosing._id"
        [staticdata]="objectChoosing.staticdata" 
        [device]="device"
        [customize]="customize">
      </app-animations-config>
    </div>
    <!-- Điều chỉnh viền nút xem thêm -->
    <div class="editor_effect-hover" *ngIf="currentViewAll.index == 4">
      <app-borders-radius-config
        [elementChoosing]="objectChoosing"
        [id_object]="objectChoosing._id" 
        [device]="device" 
        [class]="class" 
        [borderRadiusClass]="class['button']">
      </app-borders-radius-config>
    </div>
  </div>
</div>
